import { lazy } from "react";
import { PermissionGuard, PermissionEnum } from "@/modules/authentication";

const Companies = lazy(() => import("./Companies"));
const CompanyLayout = lazy(() => import("../layouts"));
const Overview = lazy(() => import("./Overview"));
const ProductBilling = lazy(() => import("./ProductBilling"));
const Employees = lazy(() => import("./Employees"));
const AllUsers = lazy(() => import("./AllUsers"));
const OpenDhc = lazy(() => import("./OpenDhc"));

const Routes = () => {
	const baseUrl = "/companies";

	return [
		{
			path: baseUrl,
			element: (
				<PermissionGuard permission={PermissionEnum.CompaniesRead}>
					<Companies />
				</PermissionGuard>
			),
		},
		{
			path: `${baseUrl}/:companyId`,
			element: (
				<PermissionGuard permission={PermissionEnum.CompaniesRead}>
					<CompanyLayout />
				</PermissionGuard>
			),
			children: [
				{
					path: "",
					element: <Overview />,
				},
				{
					path: "product-billing",
					element: <ProductBilling />,
				},
				{
					path: "employees",
					element: <Employees />,
					children: [
						{
							path: "",
							element: <AllUsers />,
						},
						{
							path: "open-dhc",
							element: <OpenDhc />,
						},
					],
				},
			],
		},
	];
};

export { Routes };
